<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="80%"
      @close="close"
    >
      <el-form ref="formRef" label-width="120px" :model="form" :rules="rules">
        <el-form-item label="订房人" prop="peopleId">
          <el-select
            v-model="form.peopleId"
            placeholder="请选择订房人"
            class="fix-width"
            clearable
            filterable
            remote
            :remote-method="fetchPeoples"
          >
            <el-option
              v-for="item in peopleList"
              :key="item.peopleId"
              :label="item.basic.name"
              :value="item.peopleId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="协议公司" prop="contractCompanyId">
          <el-select
            v-model="form.contractCompanyId"
            placeholder="请选择协议公司"
            class="fix-width"
            clearable
          >
            <el-option
              v-for="item in contractList"
              :key="item.contractCompanyId"
              :label="item.title"
              :value="item.contractCompanyId"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close(formRef)">取 消</el-button>
        <el-button type="primary" @click="save(formRef)">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createBooker } from '@/api/room'
import { getPeoples } from '@/api/people'
import commomFunction from '../common'
import { ref, reactive, getCurrentInstance } from 'vue'
export default {
  name: 'PeopleEdit',
  emits: ['fetch-data'],
  setup(_, { emit }) {
    const { proxy } = getCurrentInstance()
    const title = ref('')
    const dialogFormVisible = ref(false)
    const formRef = ref(null)
    const peopleList = reactive([])
    const { contractList, staffList } = commomFunction()
    const initForm = () => {
      return {
        bookerId: '',
        contractCompanyId: '',
        peopleId: '',
      }
    }
    const form = reactive(initForm())
    const rules = {
      contractCompanyId: [
        { required: true, trigger: 'blur', message: '请选择协议公司' },
      ],
      peopleId: [{ required: true, trigger: 'blur', message: '请选择订房人' }],
    }
    const showEdit = async (row) => {
      if (row && row.bookerId) {
        title.value = '修改订房人'
        form.bookerId = row.bookerId
        form.peopleId = row.basic.peopleId
        form.contractCompanyId = row.basic.contractCompanyId
      } else {
        title.value = '新增订房人'
      }
      findPeopleLists()
      dialogFormVisible.value = true
    }
    const fetchPeoples = async (keyword) => {
      const { list } = await getPeoples({ page: 1, size: 1000, keyword })
      peopleList.length = 0
      peopleList.push(...(list || []))
    }
    const findPeopleLists = async () => {
      const { list } = await getPeoples({ page: 1, size: 1000 })
      peopleList.length = 0
      peopleList.push(...(list || []))
    }
    const formReset = (formRef) => {
      if (!formRef) return
      formRef.resetFields()
      Object.assign(form, initForm())
    }
    const close = (formRef) => {
      formReset(formRef)
      dialogFormVisible.value = false
    }
    const save = (formRef) => {
      if (!formRef) return
      formRef.validate(async (valid) => {
        if (valid) {
          const bookerId = form.bookerId
          const data = Object.assign({}, form)
          proxy.$baseConfirm(
            `你确定要${bookerId ? '修改' : '新增'}订房人吗`,
            null,
            async () => {
              bookerId ? await createBooker(data) : await createBooker(data)
              proxy.$baseMessage(
                `${bookerId ? '修改' : '新增'}订房人成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              emit('fetch-data')
              close(formRef)
            }
          )
        } else {
          return false
        }
      })
    }
    return {
      title,
      formRef,
      form,
      rules,
      dialogFormVisible,
      staffList,
      peopleList,
      contractList,
      fetchPeoples,
      showEdit,
      close,
      save,
    }
  },
}
</script>

<style lang="scss" scoped>
@mixin size($scale: 1, $type: small) {
  @if $type == large {
    width: 343px * $scale;
  } @else {
    width: 167px * $scale;
  }
  height: 167px * $scale;
}
.avatar-uploader {
  .avatar {
    border-radius: 6px;
    transition: all 0.3s ease-in-out;
    @include size;

    &.large {
      @include size(1, large);
    }
  }
}
.icon_avatar {
  width: 50px;
  height: 50px;
}
.avatar-uploader-icon {
  border: 1px dashed #c0ccda;
  background-color: #fbfdff;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
.tags {
  margin-bottom: 5px;
}
.tags + .tags,
.tags + .button-new-tag {
  margin-left: 10px;
}
.button-new-tag {
  // margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.disabled .el-upload--picture-card {
  display: none;
}
.fix-width {
  width: 500px;
}
.mb-10 {
  margin-bottom: 10px;
}
.tips {
  color: #aaaaaa;
  margin-left: 50px;
}
.el-icon-circle-plus-outline,
.el-icon-remove-outline {
  font-size: 32px;
  vertical-align: middle;
  cursor: pointer;
}

.el-icon-circle-plus-outline {
  color: #409eff;
}

.el-icon-remove-outline {
  color: #f56c6c;
  margin-left: 15px;
}

.mr-10 {
  margin-right: 10px;
}
.mb-10 {
  margin-bottom: 10px;
}
</style>
